import { Component, OnInit, ViewChild } from '@angular/core';
import { Routes, Router, ActivatedRoute } from '@angular/router';

import { AuthenticationService } from './authentication.service';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  @ViewChild('form') form: NgForm;

  model: any = {};
  loading = false;
  errorMessage: string = null;
  user: any;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private authenticationService: AuthenticationService) { }

  ngOnInit() {
    this.authenticationService.loadProfile().subscribe(user => {
      this.user = user;
    });
  }

  change() {
    this.loading = true;
    this.errorMessage = null;
    this.authenticationService.change(this.model.password, this.model.newpassword, this.model.confirmpassword)
      .subscribe(
      data => {
        this.loading = false;
        this.router.navigate(['/']);
        this.toastr.success('Palavra-passe alterada com sucesso', '', { timeOut: 3000 });
      },
      error => {

        if (error['_body']) { // check response here.
          this.errorMessage = JSON.stringify(JSON.parse(error._body).modelState);
        } else {
          this.errorMessage = 'Ocorreu um erro a efectuar a alteração da palavra-passe.';
        }
        this.loading = false;

      });
  }
}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/auth/profile.component.ts